import { isNullable } from '@ipfabric/utils/types/isNullable';

export const isEmptyOrNullableField = (value: unknown): boolean =>
  isNullable(value) || value === '';
